module.exports = __webpack_public_path__ + "static/img/MERCEDES-BENZ.c382981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/MERCEDES-BENZ.png
// module id = MDP7
// module chunks = 1